import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Material UI Components
import { Popover, Fade, Box, Toolbar, Tooltip, Button} from '@material-ui/core';

// Icons
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';

// Material UI Custom Style
const useStyles = makeStyles(theme => ({
    Paper: {
      width: "auto",
      height: "auto",
      margin: theme.spacing(1, 0),
      padding: theme.spacing(0.5),
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius
    },
    Toolbar: {
      minHeight: "0",
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start'
    },
    Button: {
      maxWidth: "72px",
      minWidth: "44px",
      padding: theme.spacing(1),
      margin: theme.spacing(0.5),
      boxShadow: "none",
      '&:hover': {
        boxShadow: "none",
      }
    }
  }));

export default function AlignmentToolbar( {editorState, imageAlignmentType, onClickSetImageAlignment, handleCursorSetAtEnd} ) {
    const Style = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const alignmentTypes = ["ALIGNIMGLEFT", "ALIGNIMGCENTERED", "ALIGNIMGRIGHT"];
  
    const handleCloseAnchorEL = () => {
        setAnchorEl(null);
    };
  
    let open = Boolean(anchorEl);
  
    const selectionState = editorState.getSelection();
    const currentSelectionCollapsed = selectionState.isCollapsed();
    const currentSelectionHasFocus = selectionState.getHasFocus();
    const currentSelectionAnchorKey = selectionState.getAnchorKey();
    
    const contentState = editorState.getCurrentContent();
    const contentBlock = contentState.getBlockForKey(currentSelectionAnchorKey);
  
    React.useEffect(() => {
        if(currentSelectionHasFocus === true && currentSelectionCollapsed === true){
            const childElements = Array.from(document.querySelectorAll('.draftJsEmojiPlugin__image__192TI'));
    
            const parentElement = childElements.find(item => {
                const parent = item.parentElement;
                const key = parent.getAttribute("data-offset-key");
                const keyArray = key.split('-');
                const newKey = keyArray[0]
                
                return (newKey === currentSelectionAnchorKey)
            })
            
            setAnchorEl(parentElement)
            }
    }, [currentSelectionHasFocus, currentSelectionCollapsed, currentSelectionAnchorKey, setAnchorEl])
  
    return (
        <Popover
            open={open}
            onClose={handleCloseAnchorEL}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            onExiting={() => handleCursorSetAtEnd(null)}
            elevation={0}
            marginThreshold={0}
            TransitionComponent={Fade}
            transitionDuration={1000}
        >
            <Box className={Style.Paper}>
                <Toolbar className={Style.Toolbar}>
                    {
                        alignmentTypes.map((item, index) => {
                            let currentFormat = imageAlignmentType === item ? true : false;
                            const itemText = (item === "ALIGNIMGLEFT") ? "ALIGN LEFT" : (item === "ALIGNIMGCENTERED") ? "ALIGN CENTER" : "ALIGN RIGHT" ;
                            
                            return(
                                <div key={index} onMouseDown={(event) => {
                                    event.preventDefault();
                                    if(currentFormat === true){
                                        return
                                    }else{
                                        onClickSetImageAlignment(item, contentBlock)
                                        handleCloseAnchorEL()
                                    }
                                }}>
                                    <Tooltip title={itemText} placement="bottom">
                                        <Button 
                                            aria-label={itemText} 
                                            className={Style.Button} 
                                            color={(currentFormat === true) ? "primary" : "inherit"} 
                                            size="large" 
                                            variant={(currentFormat === true) ? "contained" : "text"}>
                                            {
                                                item === "ALIGNIMGLEFT" ? <FormatAlignLeftIcon />
                                                    : item === "ALIGNIMGCENTERED" ? <FormatAlignCenterIcon />
                                                        : item === "ALIGNIMGRIGHT" ? <FormatAlignRightIcon />
                                                            : ""
                                            }
                                        </Button  >
                                    </Tooltip>
                                </div>
                            );
                        })
                    }
                </Toolbar>
            </Box>
  </Popover>
)}